const ActionLinkButton = ({ handleClick, text }) => {
  return (
    <button
      onClick={handleClick}
      className="bg-transparent border-none shadow-none p-0"
    >
      <span className="text-vestelColor text-sm underline">{text}</span>
    </button>
  );
};

export default ActionLinkButton;
